import React, { useEffect, useState } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import UserRow from '../../components/UserRow'
import { Virtuoso } from 'react-virtuoso'
import UserModal from '../../components/UserModal'
import useUsers from '../../hooks/users/useUsers'


const Users = () => {
  const [filteredUsers, setFilteredUsers] = useState([])
  const [search, setSearch] = useState('')
  const [sort, setSort] = useState('up')

  const [modalOpen, setModalOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState({})

  const { data: users, refetch: refetchUsers, isLoading: loadingUsers, isSuccess: loadedUsers } = useUsers()

  useEffect(() => {
    refetchUsers()
  }, [])

  useEffect(() => {
    if (loadedUsers) {
      const sortedUsers = [...users].sort((a, b) => (a.displayName < b.displayName ? -1: 1 ) * (sort === 'up' ? 1 : -1))
      setFilteredUsers(sortedUsers)
    }
  }, [loadedUsers])

  const handleChange = (event) => {
    setSort(event.target.value)
  }

  const handleSearchChange = (event) => {
    setSearch(event.target.value)
  }

  const handleClearClick = () => {
    setSort('up')
    setSearch('')
    const sortedUsers = [...users].sort((a, b) => (a.displayName < b.displayName ? -1: 1 ) * (sort === 'up' ? 1 : -1))
    setFilteredUsers(sortedUsers)
  }

  const handleApplySearch = () => {
    const foundUsers = users
      .filter(
        user => (user.displayName || '').toLowerCase().indexOf(search.toLowerCase()) !== -1
      )
      .sort((a, b) => (a.displayName < b.displayName ? -1: 1 ) * (sort === 'up' ? 1 : -1))
    
    setFilteredUsers(foundUsers)
  }

  const handleOpenModal = (user) => {
    setSelectedUser(user)
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setSelectedUser({})
  }

  return (
    <div>
      <Typography
        variant='h4'
        sx={{
          color: '#27417A',
          fontWeight: 'bold'
        }}
      >
          Users
      </Typography>
      <Card
        elevation={0}
        sx={{
          border: 'solid 3px #27417A'
        }}
      >
        <CardContent>
          <Grid container spacing={2}>
            <Grid item md={3} xs={12}>
              <TextField
                fullWidth
                id="filter" 
                label="Filter" 
                variant="outlined"
                size='small'
                value={search}
                onChange={handleSearchChange}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <FormControl fullWidth size='small'>
                <Select
                  id='sort-select'
                  value={sort}
                  onChange={handleChange}
                >
                  <MenuItem value='up'>Sort by A - Z</MenuItem>
                  <MenuItem value='down'>Sort by Z - A</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={6} xs={12} align='end'>
              <Button 
                variant='contained'
                color='secondary'
                sx={{
                  mr: 2
                }}
                onClick={handleClearClick}
              >
                Clear
              </Button>
              <Button 
                variant='contained'
                sx={{
                  backgroundColor: '#3A6DAA'
                }}
                onClick={handleApplySearch}
              >
                Apply
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {
        loadingUsers && (
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
              mt: 2
            }}
          >
            <CircularProgress />
          </Box>
        )
      }
      {
        loadedUsers && (
          <>
            <Virtuoso
              style={{ height: '68vh', marginTop: 10 }}
              totalCount={users.length}
              data={filteredUsers}
              itemContent={(index, user) => <UserRow user={user} onClick={() => handleOpenModal(user)} />}
            /> 
          </>
        )
      }
      <UserModal open={modalOpen} user={selectedUser} onClose={handleCloseModal} />
    </div>
  )
}

export default Users